import {State} from '../types/state'
import {hasScheduleItems} from './schedule'

export const isScheduleVisible = (state: State) => hasScheduleItems(state)
